var $ = jQuery;

import { carousel } from '../lib/carousel.js';

// Location cards on the home page (a grid when there are four or fewer).
// The arrows overlap the carousel edges from md up; phones swipe.
$(document).on('ready', function(){
    $('.location-cta-swiper').each(function(){
      carousel(this, this.parentElement, {
        label: 'location',
        slidesPerView: 1.3,
        spaceBetween: 16,
        breakpoints: {
          640: { slidesPerView: 2.3 },
          1024: { slidesPerView: 3.3 },
          1400: { slidesPerView: 4.3 },
        },
      });
    });
  });
